const getZhBaseDic = code => {
  // 根据code获取字典
  return JSON.parse(sessionStorage.getItem('cbam.zh.base'))[code]
    ? JSON.parse(sessionStorage.getItem('cbam.zh.base'))[code]
    : {};
};

const getEnBaseDic = code => {
  // 根据code获取字典
  return JSON.parse(sessionStorage.getItem('cbam.en.base'))[code]
    ? JSON.parse(sessionStorage.getItem('cbam.en.base'))[code]
    : {};
};

const getZhRouteDic = code => {
  // 根据code获取字典
  return JSON.parse(sessionStorage.getItem('cbam.zh.route'))[code]
    ? JSON.parse(sessionStorage.getItem('cbam.zh.route'))[code]
    : {};
};

const getEnRouteDic = code => {
  // 根据code获取字典
  return JSON.parse(sessionStorage.getItem('cbam.en.route'))[code]
    ? JSON.parse(sessionStorage.getItem('cbam.en.route'))[code]
    : {};
};

export { getZhBaseDic, getEnBaseDic, getZhRouteDic, getEnRouteDic };
